require('../website_default/js/react/initializer.js')



// WEBPACK FOOTER //
// ./app/javascript/packs/site_default.js